import React, { useContext, useEffect } from "react";

import "./auth.css";
import UserContext from "../../context/UserContext";
import { useNavigate } from "react-router-dom";

function Auth(props) {
  const { isLogged } = useContext(UserContext);
  const navigate = useNavigate();
  useEffect(() => {
    if (isLogged) {
      navigate("/");
    }
    window.scrollTo(0, 0);
  });
  return (
    <section className="flex items-center justify-center h-auto py-32">
      {!isLogged && props.children}
    </section>
  );
}

export default Auth;
